export class SsoClient {
  constructor(
    readonly id: string,
    readonly username: string,
    readonly authUrl: string,
    readonly scope = 'client',
  ) {}
}
